export default "__VITE_ASSET__CiSGssZK__"